import React from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { useSnackbar } from 'storfox-snackbar'
import { useTranslation } from 'react-i18next'
import { prop } from 'ramda'

import { DashboardLayout } from '~/components/Layouts'
import * as ROUTES from '~/constants/routes'
import * as NAV from '~/constants/nav-titles'
import { WAREHOUSE_TABS } from '~/constants/tabs'

import { useLocationCreate, useWarehouseDetail } from '../hooks'
import { LOCATION_STATUS } from '../constants'
import { LocationCreateSerializer } from '../serializers'
import { LocationCreateForm } from '../components/LocationCreate'

function LocationCreateContainer () {
  const { t } = useTranslation()
  const { warehouseGuid } = useParams()
  const navigate = useNavigate()
  const snackbar = useSnackbar()
  const locationCreate = useLocationCreate()
  const warehouseDetail = useWarehouseDetail(warehouseGuid)

  const warehouseName = prop('name', warehouseDetail.detail)

  const initialValues = {
    status: LOCATION_STATUS.ACTIVE,
    warehouse: { guid: warehouseGuid, name: warehouseName }
  }

  const title = 'New Location'
  const message = t('Successfully created')

  const redirectPath = generatePath(ROUTES.WAREHOUSE_DETAIL_PATH, { guid: warehouseGuid, tab: WAREHOUSE_TABS.LOCATION })

  const handleSubmit = formValues =>
    locationCreate.create(LocationCreateSerializer(formValues))
      .then(() => snackbar({ message }))
      .then(() => navigate(redirectPath))

  const breadcrumbs = {
    title,
    params: [
      { guid: warehouseGuid, tab: WAREHOUSE_TABS.LOCATION, title: warehouseName }
    ]
  }

  const isLoading = locationCreate.isLoading || warehouseDetail.isLoading

  return (
    <DashboardLayout
      title={title}
      isLoading={isLoading}
      activeNav={NAV.WAREHOUSE}
      breadcrumbs={breadcrumbs}
    >
      <LocationCreateForm
        pageTitleLoading={false}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        isLoading={isLoading}
      />
    </DashboardLayout>
  )
}

export default LocationCreateContainer
